module.exports = __webpack_public_path__ + "img/ppt.a9265691.png";